<template>
    <az-template-default showMainAction
                         showMainHeader
                         show-notification
                         @paginateNotifications="paginarNotificacoesComprador"
                         @closeNotifications="resetFiltrosEPaginacao"
                         @openNotifications="buscarNotificacoes"
                         @visitNotification="marcarComoLida">
        <hal-banner-ambiente ref="halBannerAmbiente" produto-id="300" />
        <hal-menu-produtos ref="halMenuProdutos"></hal-menu-produtos>
        <template v-if="!ehPerfilFornecedor && ehAmbienteIntegracaoSGCOuHibrido" slot="main-action">
            <div class="area" v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
                <importar-processo/>
            </div>
        </template>

        <template slot="main-header">
            <div class="d-inline-flex" style="align-items: center">
                <salvamento-automatico class="mensagem-salvamento"/>
                <div class="div-informacao-conexao-websocket hidden-sm-and-down" transition="scroll-x-transition">
                    <span v-if="websocketEstaConectado" class="font-weight-black" style="font-size: 12px; color: #008000FF;">
                        Chat conectado..
                        <v-icon  size="20" class="icon-sinal-websocket-conectado">rss_feed</v-icon>
                    </span>
                    <span v-else class="primary--text font-weight-black d-flex" style="align-items: center">
                        <v-icon size="20" class="icon-sync-conexao-websocket">sync</v-icon>
                        Conectando o chat...
                    </span>
                </div>
                <notificacao-mensagem-menu />
            </div>
        </template>

        <router-view class="pb-1"/>

        <novo-chat-suporte></novo-chat-suporte>
    </az-template-default>
</template>

<script>
import {mapState} from 'vuex'
import ImportarProcesso from '@/views/pages/comprador/importar-processo/ImportarProcesso'
import GtagConfiguracao from '@/core/utils/GtagConfiguracao'
import {actionTypes, mutationTypes} from '@/core/constants'
import NotificacaoMensagemMenu from '@/views/pages/commons/chat-compra-direta/notificacao/NotificacaoMensagemMenu'
import axios from 'axios'
import SalvamentoAutomatico from '@/views/components/SalvamentoAutomatico.vue'
import WebsocketHelper from '@/core/utils/WebsocketHelper'
import NovoChatSuporte from '@/views/pages/commons/chat/NovoChatSuporte'

export default {
    components: {
        NovoChatSuporte,
        SalvamentoAutomatico,
        NotificacaoMensagemMenu,
        ImportarProcesso,
    },
    computed: {
        ehPerfilFornecedor() {
            return this.$store.state.loki.user.type === 'EXTERNO'
        },
        ...mapState(['loki', 'parametros', 'websocketService']),
        ehPerfilComprador(){
            return this.loki.user.domainId && this.loki.user.domainType === 'ESTRUTURA_ORGANIZACIONAL'
        },
        ehSessaoValida(){
            return this.loki.user.domainId && this.loki.user.domainType !== 'DEFAULT'
        },
        websocketEstaConectado() {
            return this.websocketService !== null
        },
        ehAmbienteIntegracaoSGCOuHibrido() {
            const integracao = this.parametros.propriedadesCompraDiretas.integration
            return (integracao.sistemaDeGestao === 'SGC' || integracao.sistemaDeGestao === 'HIBRIDO' || integracao.sistemaDeGestao === 'file-system')
        },
    },
    async mounted() {
        window.addEventListener('focus', this.atualizarSessao)
        GtagConfiguracao.initialize(this.parametros.propriedadesCompraDiretas)

        if(this.ehPerfilComprador) {
            this.processarNovidade()
            this.processarNovidadesNovaVersao()
        }
        this.configurarHalMenuProduto()
        this.configurarBannerAmbiente()
        await this.contarNotificacoesNaoLidas()

        /**
         * Forcando a conexão do websocket
         */
        const timeoutPopupWebsocket = setTimeout(() => {
            if(!this.websocketEstaConectado)
                this.processarConexaoWebsocketViaPopup()
            else clearTimeout(timeoutPopupWebsocket)
        }, 15000)
    },
    async beforeDestroy(){
        window.removeEventListener('focus', this.atualizarSessao)
    },
    async created() {
        this.configurarRequestHalWebComponent()
    },
    methods: {
        async atualizarSessao() {
            if(this.ehPossivelAtualizarSession()) {
                await this.$store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO,
                    {
                        dominioClienteId: this.loki.user.domainId,
                        dominioTipo: this.loki.user.domainType
                    }
                )
            }
        },
        ehPossivelAtualizarSession(){
            return (this.loki.user.domainId && this.loki.user.domainType)
        },
        processarNovidade() {
            if (this.haNovidades(this.loki.product)) {
                this.updateVisualizacaoNovidade('NAO_VISUALIZADO')
                this.updateUltimaVersao(this.loki.product.version)
            }
        },
        processarNovidadesNovaVersao(){

            const permiteVisualizacaoNovidades = this.haNovidadeNaoVisualizada()

            if(permiteVisualizacaoNovidades) {
                const span = document.createElement('span')
                span.classList.add('bagde', 'novidade-bagde')
                span.setAttribute('id', 'id-novidade')
                span.innerHTML = '&#128276;'
                span.classList.toggle('sinalizar_novidade', permiteVisualizacaoNovidades)

                const novidade = document.querySelector('aside.az-aside .az-aside .menu .v-list__group.menu-item .az-submenu .az-submenu__tile .v-list__tile__title')
                novidade.classList.add('novidade', 'div-novidade-and-bagde')
                novidade.appendChild(span)

                novidade.parentElement.parentElement.addEventListener('click', (event) => {
                    event.stopPropagation()
                    this.updateVisualizacaoNovidade('VISUALIZADO')
                    novidade.removeChild(span)
                })
            }
        },
        haNovidadeNaoVisualizada(){
            return 'NAO_VISUALIZADO' === this.getVisualizacaoNovidade()
        },
        configurarHalMenuProduto(){
            const halMenuProdutos = this.$refs.halMenuProdutos
            const azToolbar = document.querySelector('.v-toolbar__content')
            const azAvatar = document.querySelector('.az-avatar')

            azToolbar.insertBefore(halMenuProdutos, azAvatar)
        },
        configurarRequestHalWebComponent(){
            window.hal = {
                http: {
                    get: async ({url}) => axios.get(url),
                    post: async ({url, body}) => axios.post(url, body),
                    put: async ({url, body}) => axios.put(url, body),
                    delete: async ({url}) => axios.delete(url),
                },
            }
        },
        async contarNotificacoesNaoLidas(){
            if(this.ehPerfilComprador)
                await this.$store.dispatch(actionTypes.COMPRADOR.CONTAR_NOTIFICACOES_NAO_LIDAS_COMPRADOR)
            else if(this.ehSessaoValida)
                await this.$store.dispatch(actionTypes.FORNECEDOR.CONTAR_NOTIFICACOES_NAO_LIDAS_FORNECEDOR)
        },
        async buscarNotificacoes(){
            if(this.ehPerfilComprador)
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_NOTIFICACOES_COMPRADOR)
            else if(this.ehSessaoValida)
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_NOTIFICACOES_FORNECEDOR)
        },
        paginarNotificacoesComprador(){
            this.$store.commit(mutationTypes.SET_NOTIFICACOES_PAGE)
            this.buscarNotificacoes()
        },
        resetFiltrosEPaginacao(){
            this.$store.commit(mutationTypes.SET_NOTIFICACOES_PAGE, 1)
            this.$store.commit(mutationTypes.NOTIFICACOES_RESET_FILTROS)
        },
        marcarComoLida(message){
            if(!message.read)
                this.$store.dispatch(actionTypes.MARCAR_NOTIFICACAO_LIDA, message.id)
        },
        processarConexaoWebsocketViaPopup() {
            const htmlConectando = '<h3>Chat Compra Direta:</h3> <p> <img src="/compra-direta/assets/Animation - 1724166100409.gif" height="100" /> </p>' +
                '<p class="primary--text text--primary"> Processando a conexão websocket para o funcionamento do chat... </p>'
            const htmlConectado = '<h3>Chat Compra Direta:</h3> <p> <img src="/compra-direta/assets/Animation - 1720558538486.gif" height="100" /> </p>' +
                '<p class="primary--text text--primary"> Conectado com sucesso  </p>'

            const features = `resizable=yes, scrollbars=false, width=300, height=250, top=${ screen.height - 250 }, left=${ screen.width - 300 }`
            const popup = window.open('/compra-direta/api/public/ws-compra-direta', 'popUpWindow', features)

            popup.onload = () => {
                popup.document.title = 'Compra Direta - Conexão Websocket'
                popup.document.body.style.backgroundColor = 'white'
                popup.document.body.style.color = '#0067A5'

                popup.document.body.removeChild(popup.document.body.firstElementChild)

                const divBodyPopup = popup.document.createElement('div')

                divBodyPopup.style.textAlign = 'center'

                divBodyPopup.innerHTML = htmlConectando
                popup.document.body.appendChild(divBodyPopup)

                const intervalo = setInterval(() => {
                    if(this.websocketEstaConectado) {
                        popup.document.body.style.backgroundColor = 'green'
                        popup.document.body.style.color = 'white'
                        divBodyPopup.innerHTML = htmlConectado

                        clearInterval(intervalo)

                        const timeout = setTimeout(() => {
                            popup.close()
                            clearTimeout(timeout)
                        }, 3000)
                    }
                }, 2000)
            }
        },
        async conectarComWebsocket(){
            if(this.ehSessaoValida){
                await (new WebsocketHelper()).conectar(this.$store.state.loki.user, this.$store.state.token)

                const intervalo = setInterval(async () => {
                    if(!this.$store.state.websocketService)
                        await (new WebsocketHelper()).conectar(this.$store.state.loki.user, this.$store.state.token)
                    else
                        clearInterval(intervalo)
                }, 10000)
            }
        },
        configurarBannerAmbiente(){
            const halBannerAmbiente = this.$refs.halBannerAmbiente
            const applicationWrap = document.querySelector('.application--wrap')
            const azToolbar = document.querySelector('nav.v-toolbar')
            const azAside = document.querySelector('aside.az-aside')
            const mainContent = document.querySelector('main.v-content')

            applicationWrap.insertBefore(halBannerAmbiente, azToolbar)

            customElements.whenDefined('hal-banner-ambiente').then(() => {
                setTimeout(() => {
                    const altura = halBannerAmbiente.shadowRoot.querySelector('div').offsetHeight
                    const alturaTopo = azToolbar.offsetHeight + altura

                    azAside.querySelector('.az-aside').style['padding-top'] = `${altura}px`
                    azToolbar.style['padding-top'] = `${altura}px`
                    mainContent.style['padding-top'] = `${alturaTopo}px`
                }, 500)
            })
        }
    },
    watch: {
        websocketService(value){
            if(!value)
                this.conectarComWebsocket()
        }
    }
}
</script>

<style lang="stylus">
    html, body, .application
        font-family 'Open Sans', sans-serif

    *, ::after, ::before
        box-sizing border-box

    .notification i.white--text
        color rgb(119, 119, 119) !important

    table.v-table thead tr
        height auto !important

    .az-table-list tbody tr
        border-bottom 1px solid #e7e7e7 !important

        td
            font-weight 400
            height 40px
            color #777
            font-size 13px

    .az-menu .v-list__tile__action .v-icon
        font-size 15px
        color #efefef !important

    .az-menu .v-list a:hover:not(.v-list__tile--active)
        background-color var(--v-secondary-darken1) !important

    .az-container .az-table-list thead tr:first-child th
        white-space normal

    .az-table-list .v-table
        .v-datatable__progress, .v-datatable__progress th
            height 0 !important
            padding 0 !important

        .az-checkbox .v-input__slot
            border 0
            padding 0

        .v-input__slot
            background-color #fff

    .table-actions
        text-align center !important

        a
            color #777
            display inline-flex
            align-items center
            justify-content center

        i
            font-size 16px

    .actions-item
        padding-left  5px
        padding-right 5px

    .botao-menor i
        font-size 13px !important

    .v-tooltip__content.menuable__content__active
        max-width 500px

    .card-dados
        border 1px solid #ebebeb
        margin 0 auto 2rem
        border-radius 2px

        tr
            border-bottom 1px solid #e7e7e7 !important

        &__titulo
            font-size 1.1rem
            color #777
            padding .6rem .8rem
            border-bottom 1px solid #ebebeb
            background-color #ebebeb
            box-sizing border-box
            margin-bottom .6rem

        .layout
            margin 0 !important

        .az-table-list .v-table tbody tr:nth-child(even)
            background-color #f9f9f9

    .area
        color #fff
        box-sizing border-box
        padding 20px
        text-align center
        border-bottom 1px solid rgba(255, 255, 255, .1)

        .call-to-action
            padding 10px 20px

        .fa-upload
            font-size 14px

        h1
            font-size 24px

        p
            margin-bottom 0
            text-transform uppercase

    .v-navigation-drawer--mini-variant .area
        padding 20px 10px

    .az-avatar
        white-space nowrap

    .az-search .input-search
        width 400px !important

    .az-logo .main
        width 125px
        transition all .2s linear

    .symbol
        width 45px !important
        transition all .2s linear

    .az-about__version
        font-size 9px

    .az-checkbox
        .v-icon.material-icons.theme--light
            margin-left 1.8px
            margin-top 1.8px

        .v-input--selection-controls__ripple
            margin-top 0
            margin-left 0

    .painel-item .v-expansion-panel__body
        border-top 1px solid rgba(0, 0, 0, .12)

    .ajuste-acoes
        padding 20px !important
        border-top 1px solid #ebebeb
        margin-top 0

    .table-arquivos-consulta .v-input__slot
        border 0
        background-color inherit !important

    .table-arquivos-consulta, .tabela-linha, .tabela-email
        tr:last-child
            border-bottom 0 !important

    .tabela-itens-proposta .v-text-field
        padding-top 0
        font-size 13px

    .tabela-lances, .tabela-meus-lotes, .tabela-todos-lotes, .tabela-itens-reajuste, .tabela-item-reajuste
        thead tr th
            font-weight bold

    .az-form-content
        margin-top 0

        .az-text
            margin-bottom 0

        .v-text-field__details
            margin-bottom 10px

    .botao-excluir a
        color #777 !important

    .area-novo
        display flex
        align-items center
        padding 0 16px

        &__input
            padding-top 0
            width 400px;
            margin 0 0 0 10px
            flex 0

            .v-input__control
                height 40px
                display block

            .v-input__control, .v-input__slot
                width 400px

        .v-btn
            min-width 20px

    .area-conteudo .v-stepper
        box-shadow none

        &__header
            align-items center
            flex-wrap nowrap
            position relative
            box-shadow none

        &__step
            text-align center
            flex-direction column
            cursor pointer

            &:hover .v-stepper__label
                color var(--v-primary-darken1) !important

        &__step__step
            height 40px
            min-width 40px
            width 40px
            font-size 16px
            margin 0 0 5px

            &:hover
                background-color var(--v-primary-darken1) !important
                cursor pointer

        &__step--active .v-stepper__label, &__step--complete .v-stepper__label
            color var(--v-primary-base) !important
            font-weight 600
            text-shadow none !important

    .swiper-slide
        p
            margin-bottom 0

    .borda-linha .v-expansion-panel__header
        border-bottom 1px solid #ebebeb

    .mensagem-erro
        font-size 12px
        color rgb(255, 82, 82)

    .alinhar-campo
        position relative

    .alinhar-campo .mensagem-erro
        right 0
        bottom 0
        margin-right 10px

    .clear-button.v-input--is-disabled .v-icon--disabled, .campo-moeda .v-messages
        display none

    .campo-moeda
        .v-icon
            font-size 13px !important

        .v-text-field__details
            margin-bottom 0

    .resultado__aba
        & .v-tabs__container
            justify-content space-between
            align-items center
            height auto

        &-item .active
            color var(--v-primary-base)

    .situacao-adjudicado
        color var(--v-primary--text)
        font-weight 600

    .mensagem-salvamento
        color var(--v-primary-base)
        margin-right 1rem
        font-size 12px

    .az-table-list .v-text-field > .v-input__control > .v-input__slot:before
        border-color transparent

    .cabecalho-painel .v-expansion-panel__header, .tabela-itens-reajuste
    .linha-info:hover + .v-datatable__expand-row, .tabela-item-reajuste .linha-info:hover + .v-datatable__expand-row
        background-color #f9f9f9

    .az-table-list .v-table tbody tr:hover:not(.v-datatable__expand-row),
    .tabela-itens-reajuste .v-datatable__expand-row:hover, .tabela-item-reajuste .v-datatable__expand-row:hover
        background-color #f3f3f3

    .az-table-list .v-input--is-disabled .v-input__slot
        background-color #ebebeb

        input
            color #797979

        ::placeholder /* Chrome, Firefox, Opera, Safari 10.1+ */
            color #cacaca
            opacity 1 /* Firefox */

        :-ms-input-placeholder /* Internet Explorer 10-11 */
            color #cacaca

        ::-ms-input-placeholder  /* Microsoft Edge */
            color #cacaca

    .az-table-list.tabela-ranking
        .v-table tbody tr:nth-child(even)
            background-color #fff

    .alinhar-direita input
        text-align right

    .tabela-item-reajuste tbody tr
        border-bottom 0 !important

    .v-snack__content
        height auto
        padding 10px 15px

    .swiper-pagination-bullet-active
        background-color var(--v-primary-base) !important

    .analise
        &__scroll
            overflow-y hidden

       .az-pdf-container
           background-color transparent

           .az-pdf-toolbar
                border-bottom 1px solid #e9e9e9

            .Viewer
                background-color #f8f9fa

    .erro-inicializacao
        width 100%
        padding 0
        text-align center
        color #555
        height 80vh
        display flex
        justify-content center
        align-items center

        i
            font-size 36px

        p
            font-size 18px
            margin 10px 0 0
            font-weight 600

        .mensagem
            color rgb(255, 82, 82)

    .fade-enter-active, .fade-leave-active
        transition opacity .3s ease

    .fade-enter, .fade-leave-to
        opacity 0

    .az-drop-file a
        background-color var(--v-secondary-base) !important
        border 1px solid var(--v-secondary-base) !important

        &:hover
            background-color var(--v-secondary-lighten1) !important

    .checkbox-item label, .alinhar-todos label
        font-size 14px

    .de-abas
        margin 0 auto 60px

        .v-tabs
            padding-top 5px
            background-color var(--v-primary-base)

        &__area .v-tabs__bar
            background-color var(--v-primary-base) !important

        &__area .v-tabs__container
            border-bottom 0
            justify-content space-between

        &__item .v-tabs__item
            color #fff
            opacity 1 !important
            -moz-border-radius-bottomleft 0
            border-bottom-left-radius 0
            -moz-border-radius-bottomright 0
            border-bottom-right-radius 0
            padding 10px 20px 13px

        &__item .active
            border-width 0
            border-color #fff
            border-style solid
            background-color #fff
            color var(--v-primary-darken1)
            font-weight bold !important

        &__item .v-tabs__item--active
            border 0
            font-weight 500

        &__item .v-tabs__item--disabled
            color #fff !important
            opacity .5 !important

        &__badge
            background-color var(--v-primary-darken1)
            color #fff
            font-size 14px
            border-radius 50%
            height 25px
            width 25px
            -webkit-transition .3s cubic-bezier(.25, .8, .5, 1)
            transition .3s cubic-bezier(.25, .8, .5, 1)
            margin 0 10px 0 auto
            padding 2px

    .de-info
        margin -5px 15px 0
        color white
        display block
        padding-top 6px
        box-sizing border-box

        p
            margin-bottom 0

    .lista-menu .v-list__tile
        border-bottom 1px solid #ebebeb

    .lista-menu .v-list__tile:hover
        background-color #eee

    .dados-gerais .az-drop-file
        height 0 !important
        padding 0
        border 0

        .center
            margin 0

    .tabela-itens-edicao, .tabela-itens-manual-edicao
        .v-input--radio-group--row .v-input--radio-group__input
            flex-wrap unset

        .v-input--selection-controls .v-input__control
            height 20px

        .ajuste-fundo .v-input__slot
            background-color inherit !important

    .botao-motivo a
        color #777

        i
            font-size 10px

    .mensagem-quando-vazio
        color #7f7f7f
        font-size 16px
        text-align center
        padding 10px 0
        margin-bottom 0

    .v-dialog.v-dialog--active .v-card__actions
        padding 16px 0 0
        border-top 1px solid #ebebeb

    .modal-title
        font-size 16px !important

    .acao-expandir-recolher
        margin 5px 0

    .area-importacao
        .v-text-field__details
            margin-bottom 0

        .az-drop-file
            height 0 !important
            padding 0
            border 0
            margin 0 0 0 20px
            width 110px

            .center
                margin 0

    div.novidade.div-novidade-and-bagde
        display flex
        flex-direction row
        justify-content space-between

        span.bagde.novidade-bagde#id-novidade
            font-size 14px

        span.bagde.sinalizar_novidade
            animation sinalizar_novidade .1s infinite alternate


    @media (max-width 960px)
        .resultado
            &__aba .v-tabs__container
                justify-content center

    @media (max-width 775px)
        .cabecalho-etapas .v-toolbar__content
            padding 0

    @media (max-width 720px)
        .tabela-itens-proposta .mensagem-erro
            position inherit

        .total-mobile
            margin 16px 10px

        .total-listagem
            margin 0 0 16px

        .table-itens, .tabela-item-detalhe, .lista-lote-item, .tabela-itens-reajuste, .tabela-item-reajuste
            tr
                border 0

        .card-dados__mobile
            border 0

            .painel-itens__linha
                border 1px solid #ebebeb

        .table-arquivos-consulta tr:last-child
            border-bottom  1px solid #ebebeb !important

        .erro-inicializacao
            padding 30px

            i
                font-size 30px

            p
                font-size 14px

    @media only screen and (min-width 600px)
        .v-snack--right.v-snack--top
            -webkit-transform translateY(68px)
            transform translateY(68px)

    @media (max-width 600px)
        .acao-expandir-recolher
            display none !important

    @media (max-width 500px)
        .az-container
            margin 0

        .az-pagination .az-select-pagination
            height 50px

        .de-abas
            margin 0

        .az-back-button
            margin-bottom 25px

        .cabecalho .v-toolbar__content
            padding 0

        .card-dados__titulo
            font-size 1rem

        .de-abas .az-actions-form
            flex-direction column
            text-align center

            button
                margin 0 auto 20px !important

                &:first-child
                    order 3

                &:nth-child(2)
                    order 2

            .align-right
                order 1

        .az-form-content, .az-form
            padding 10px

        .de-info
            display none

    @media (max-width 480px)
        .area-conteudo__linha
            .v-stepper__header
                height 102px

            .v-stepper__step
                padding 0

    @keyframes sinalizar_novidade
        from{
            transform: rotate(10deg);
        }
        50% {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(-10deg);
        }

    /* DIV INFORMAÇÔES WEBSOCKET */
    div.div-informacao-conexao-websocket
        /*color var(--v-primary-base)*/
        margin-right 5px

        /* CONECTANDO */
        i.icon-sync-conexao-websocket
            color var(--v-primary-base) !important
            animation sync_conexao_websocket 1s infinite

        i.icon-sinal-websocket-conectado

            animation sinal_websocket_conectado 1s infinite alternate


    @keyframes sync_conexao_websocket
        from{
            transform: rotate(0deg);
        }
        20%{
            transform: rotate(72deg);
        }
        40% {
            transform: rotate(144deg);
        }
        60% {
            transform: rotate(216deg);
        }
        80% {
            transform: rotate(288deg);
        }
        to {
            transform: rotate(360deg);
        }

    /* CHAT CONECTADO */
    @-webkit-keyframes sinal_websocket_conectado
        from   { color: #9493939D }
        40% { color: #949393A8}
        80% { color: #008000A9}
        to  { color:green }


    @keyframes sinal_websocket_conectado
        from   { color: #9493939D }
        40% { color: #949393A8}
        80% { color: #008000A9}
        to  { color:green }
</style>
